import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="product-gallery"
// Swaps the product page's main image when a thumbnail is chosen. The
// thumbnails are real links to the full-size image, so with JavaScript off (or
// before Stimulus connects) they still open the picture instead of doing
// nothing — the swap is an enhancement, never the only way through.
export default class extends Controller {
	static targets = ["main", "thumb"];

	select(event) {
		event.preventDefault();
		const thumb = event.currentTarget;
		const src = thumb.dataset.productGallerySrcValue;
		if (!src) return;

		this.mainTarget.src = src;
		this.mainTarget.alt = thumb.dataset.productGalleryAltValue || "";

		for (const other of this.thumbTargets) {
			const active = other === thumb;
			other.classList.toggle("border-carmesim-600", active);
			other.classList.toggle("border-2", active);
			other.classList.toggle("border-line", !active);
			other.setAttribute("aria-current", active ? "true" : "false");
		}
	}
}
